/**
 * Robust API base URL resolver.
 *
 * Default: use REACT_APP_BACKEND_URL (baked at build time by Emergent).
 *
 * Safety net: if the app is served from a custom production domain (.fr/.com/…)
 * BUT the baked env still points to an Emergent preview URL (e.g. salle-demo.emergent.host),
 * fall back to window.location.origin. This prevents CORS failures when a stale
 * build gets deployed to a new custom domain.
 */
function resolveApiBase() {
  const env = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');
  if (typeof window === 'undefined') return env;
  const origin = window.location.origin;

  const isCustomDomain = /^https?:\/\/[^/]+\.(fr|com|io|app|co|net|org|eu)(\/|$)/i.test(origin);
  const envIsEmergentPreview = /emergentagent\.com|emergent\.host/.test(env);

  // Production custom domain + stale Emergent env → prefer same-origin
  if (isCustomDomain && envIsEmergentPreview) return origin;

  // Preview or local: trust env; fallback to origin only if env is missing
  return env || origin;
}

export const API_BASE = resolveApiBase();
export const API = `${API_BASE}/api`;
